import React from 'react';
import { Entity } from '@backstage/catalog-model';
import {
  useEntity,
  MissingAnnotationEmptyState,
} from '@backstage/plugin-catalog-react';
import { Routes, Route } from 'react-router-dom';
import { buildRouteRef } from '../routes';
import { WorkflowRunDetails, WorkflowRunsTable } from './Workflow';
import { CLOUDBUILD_ANNOTATION } from './useProjectName';
import { TriggersTable } from './Trigger';
import { Grid } from '@material-ui/core';

/** @public */
export const isCloudbuildAvailable = (entity: Entity) =>
  Boolean(entity.metadata.annotations?.[CLOUDBUILD_ANNOTATION]);

/** @public */
export const Router = () => {
  const { entity } = useEntity();

  if (!isCloudbuildAvailable(entity)) {
    return <MissingAnnotationEmptyState annotation={CLOUDBUILD_ANNOTATION} />;
  }
  return (
    <Routes>
      <Route
        path="/"
        element={
          <Grid container spacing={3} alignItems="stretch">
            <Grid item md={12}>
              <WorkflowRunsTable entity={entity} />
            </Grid>
            <Grid item md={12}>
              <TriggersTable entity={entity} />
            </Grid>
          </Grid>
        }
      />
      <Route
        path={`${buildRouteRef.path}`}
        element={<WorkflowRunDetails entity={entity} />}
      />
    </Routes>
  );
};
